

import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const getIndiaQcSkuLabels = createAsyncThunk('getIndiaQcSkuLabels', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/get-india-qc-sku-labels`
  try {
    const response = await axios.post(URL, data)
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `india_qc_sku_labels.pdf`);
    document.body.appendChild(link);
    link.click();
    return response
} catch (error) {
    return handleErrorResponse(error, rejectWithValue)
}
});
